import { numify } from 'numify';
/////////////////////////////////////////////////////////////
import {
	ArrowRight,
	Checked,
	CoinImage,
	DiamondImage,
} from '@/app/shared/components';
import { Reward } from '@/core/interfaces';

interface TaskProps {
	reward: Reward;
	onSelectTask: (selectedReward: Reward) => void;
}

export const TaskItem: React.FC<TaskProps> = ({
	reward,
	onSelectTask,
}: TaskProps) => {
	/*********************
	// #region Template
	**********************/
	return (
		<div
			className="flex rounded-2xl items-center bg-vottun-900/50 option-menu-setting p-3 relative"
			onClick={() => {
				onSelectTask(reward);
			}}
		>
			{(reward.availableForCollecting || !reward.requestedByUser) && (
				<div className="aspect-square w-4 rounded-full bg-red-600 absolute right-[-5px] top-[-5px] text-center text-xs font-bold">
					!
				</div>
			)}
			<div className="flex flex-row w-full gap-3 items-center">
				<img
					src={reward.image}
					className={'w-[48px] h-[48px] rounded-lg'}
				/>
				<div className="flex flex-col">
					<p className="text-sm font-bold">{reward.title}</p>
					<div className="flex gap-4">
						<div className="flex justify-start items-center gap-1">
							<CoinImage width={32} />
							<p className="pl-1 text-shadow font-bold text-md">
								+{numify(reward.reward)}
							</p>
						</div>
						{reward.diamondsReward > 0 && (
							<div className="flex justify-start items-center gap-1">
								<DiamondImage width={26} />
								<p className="pl-1 text-shadow font-bold text-md">
									+{numify(reward.diamondsReward)}
								</p>
							</div>
						)}
					</div>
				</div>
			</div>
			<div className="flex flex-col items-center self-center">
				{reward.completed ? (
					<Checked />
				) : (
					<ArrowRight fillcolor="white" />
				)}
			</div>
		</div>
	);
};
